import React from "react";
import { FaCheckCircle } from "react-icons/fa";

function LaunchDeFi() {
  return (
    <div className="about-area pt-5 pb-5 mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2 text-center mb-5">
            <h2 className="title fw-bold">
              Launch DeFi Staking Platforms & Unleash New Way of Financing
            </h2>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-5 text-center">
            <div className="thumb">
              <img
                src="/assets/img/illustration/3.png"
                alt="Launch DeFi Staking"
                style={{ maxWidth: "80%" }}
              />
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1">
            <div className="">
              <p
                style={{
                  fontSize: "16px",
                  color: "#555",
                  marginBottom: "30px",
                }}
              >
                DeFi staking environments have revolutionized digital financing
                landscapes by directly engaging users and eliminating
                restrictive intermediates.
              </p>

              <ul className="list-unstyled">
                <li className="d-flex mb-4 align-items-start">
                  <div className="icon text-primary mt-1 me-3">
                    <FaCheckCircle size={18} />
                  </div>
                  <div>
                    <h5 className="fw-bold fs-6 mb-1">
                      Provide passive income
                    </h5>
                    <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                      Users consistently accumulate native tokens securing
                      immense fiscal value stably.
                    </p>
                  </div>
                </li>

                <li className="d-flex mb-4 align-items-start">
                  <div className="icon text-primary mt-1 me-3">
                    <FaCheckCircle size={18} />
                  </div>
                  <div>
                    <h5 className="fw-bold fs-6 mb-1">
                      Participation in governance
                    </h5>
                    <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                      Stakers actively democratize platform decision processes
                      scaling accountability.
                    </p>
                  </div>
                </li>

                <li className="d-flex mb-4 align-items-start">
                  <div className="icon text-primary mt-1 me-3">
                    <FaCheckCircle size={18} />
                  </div>
                  <div>
                    <h5 className="fw-bold fs-6 mb-1">Enhancing liquidity</h5>
                    <p style={{ fontSize: "14px", color: "#666", margin: 0 }}>
                      By locking vast pools, smart networks shield against
                      high-impact dumps, promoting robust equilibrium trading
                      environments.
                    </p>
                  </div>
                </li>
              </ul>

              <a href="#" className="btn btn-style-one mt-3">
                Talk to our Experts
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LaunchDeFi;
